import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './unidadeForm';
import FormatUtils from '../common/formatUtils/FormatUtils';

import { setModoTela, initForm, salvar, excluir, getLista, getListaCidade } from './unidadeActions';

class Unidade extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaCidade();
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th colspan={1}>Nome</Th>
								<Th alignCenter>Custo</Th>
								<Th alignCenter>Tipo</Th>
								<Th colspan={1}></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`${item.nome}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.nome}</Td>
									<Td alignCenter>{FormatUtils.formatarValorTela(item.custo_operacao, 4)}</Td>
									<Td alignCenter>{item.logistica_direta ? 'LOGÍSTICA DIRETA' : 'BASE'}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													custo_operacao: FormatUtils.formatarValorTela(item.custo_operacao, 4),
													estoque_minimo_s10: FormatUtils.formatarValorTela(item.estoque_minimo_s10, 0),
													estoque_minimo_s500: FormatUtils.formatarValorTela(item.estoque_minimo_s500, 0),
													vazao_bomba_carga_s10: FormatUtils.formatarValorTela(item.vazao_bomba_carga_s10, 0),
													vazao_bomba_descarga_s10: FormatUtils.formatarValorTela(item.vazao_bomba_descarga_s10, 0),
													vazao_bomba_carga_s500: FormatUtils.formatarValorTela(item.vazao_bomba_carga_s500, 0),
													vazao_bomba_descarga_s500: FormatUtils.formatarValorTela(item.vazao_bomba_descarga_s500, 0)
												});
												this.props.initForm({
													...item,
													custo_operacao: FormatUtils.formatarValorTela(item.custo_operacao, 4),
													estoque_minimo_s10: FormatUtils.formatarValorTela(item.estoque_minimo_s10, 0),
													estoque_minimo_s500: FormatUtils.formatarValorTela(item.estoque_minimo_s500, 0),
													vazao_bomba_carga_s10: FormatUtils.formatarValorTela(item.vazao_bomba_carga_s10, 0),
													vazao_bomba_descarga_s10: FormatUtils.formatarValorTela(item.vazao_bomba_descarga_s10, 0),
													vazao_bomba_carga_s500: FormatUtils.formatarValorTela(item.vazao_bomba_carga_s500, 0),
													vazao_bomba_descarga_s500: FormatUtils.formatarValorTela(item.vazao_bomba_descarga_s500, 0)
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													custo_operacao: FormatUtils.formatarValorTela(item.custo_operacao, 4),
													estoque_minimo_s10: FormatUtils.formatarValorTela(item.estoque_minimo_s10, 0),
													estoque_minimo_s500: FormatUtils.formatarValorTela(item.estoque_minimo_s500, 0),
													vazao_bomba_carga_s10: FormatUtils.formatarValorTela(item.vazao_bomba_carga_s10, 0),
													vazao_bomba_descarga_s10: FormatUtils.formatarValorTela(item.vazao_bomba_descarga_s10, 0),
													vazao_bomba_carga_s500: FormatUtils.formatarValorTela(item.vazao_bomba_carga_s500, 0),
													vazao_bomba_descarga_s500: FormatUtils.formatarValorTela(item.vazao_bomba_descarga_s500, 0)
												});
												this.props.initForm({
													...item,
													custo_operacao: FormatUtils.formatarValorTela(item.custo_operacao, 4),
													estoque_minimo_s10: FormatUtils.formatarValorTela(item.estoque_minimo_s10, 0),
													estoque_minimo_s500: FormatUtils.formatarValorTela(item.estoque_minimo_s500, 0),
													vazao_bomba_carga_s10: FormatUtils.formatarValorTela(item.vazao_bomba_carga_s10, 0),
													vazao_bomba_descarga_s10: FormatUtils.formatarValorTela(item.vazao_bomba_descarga_s10, 0),
													vazao_bomba_carga_s500: FormatUtils.formatarValorTela(item.vazao_bomba_carga_s500, 0),
													vazao_bomba_descarga_s500: FormatUtils.formatarValorTela(item.vazao_bomba_descarga_s500, 0)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.unidade,
	modoTela: state.unidade.modoTela,
	lista: state.unidade.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista, getListaCidade }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Unidade);
